import './wallboard-list.component.ajscss';

import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { WallboardConfRouter } from '@wallboard-conf/wallboard-conf-router';
import { IWallboardService } from '@wallboard/wallboard.service';
import { fromJson, IComponentController, IComponentOptions, IFormController, isObject } from 'angular';
import { Path } from 'src/app/app-routing.module';

import { DisplayDeprecatedComponent, ProfileFacade, ToastClass, ToastType } from '@contact/upgrade';

import templateUrl from './wallboard-list.component.ajs.html';

class WallboardListCtrl extends DisplayDeprecatedComponent implements IComponentController {
  private filters: any = {};
  public domainList: any[] = [];
  // Table
  private rows: any[] = [];
  public columns = [
    { name: 'name', sortName: 'name.keyword' },
    { name: 'login', sortName: 'login' },
    { name: 'domain', sortName: null },
  ];
  // Sort
  private sortKey = '';
  private reverse = false;
  // Pagination
  public totalItems = 0;
  private itemsPerPage = 10;
  public maxSize = 3; // Number of pager buttons to show
  private currentPage = 1;
  // Modal
  public newWallboardState = false;
  public newWallboardImportState = false;
  public confirmDeleteState = false;
  private wallboardIdToDelete: any = null;
  private wallboardIndexTodelete: any = null;
  private newWallboard: any = {
    name: '',
    login: '',
    mail: '',
    domain: null,
    positioning: '',
    spacing: '12',
    template: '',
  };
  public regex = /^[a-zA-Z0-9]*$/;
  public wbForm: IFormController;

  constructor(
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly wallboardService: IWallboardService,
    private readonly profileFacade: ProfileFacade,
    private readonly router: WallboardConfRouter
  ) {
    super();
  }

  $onInit() {
    this.filters.domain = {};
    this.getWallboardList();

    this.wallboardService.getDomains().then(
      response => {
        let temp: any[] = [];
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.forEach(domain => {
            let newDomain = {
              uuid: domain.domainUuid,
              name: domain.domainName,
            };
            temp.push(newDomain);
          });
        }
        this.domainList = temp;
      },
      () => (this.domainList = [])
    );
  }

  onChangeDomain() {
    if (this.newWallboard.domain == null || Object.keys(this.newWallboard.domain).length === 0) {
      if (this.wbForm['domain']) {
        this.wbForm['domain'].$setValidity('nodomain', false);
      }
    } else {
      if (this.wbForm['domain']) {
        this.wbForm['domain'].$setValidity('nodomain', true);
      }
    }
  }

  public sort(keyName) {
    this.sortKey = keyName;
    this.reverse = !this.reverse;
    this.currentPage = 1;
    this.getWallboardList();
  }

  pageChanged() {
    this.getWallboardList();
  }

  resetFilter() {
    this.filters = {};
    this.filters.domain = {};
    this.getWallboardList();
  }

  getWallboardList() {
    this.wallboardService
      .execWallboardRequest(
        this.filters,
        this.itemsPerPage,
        (this.currentPage - 1) * this.itemsPerPage,
        this.sortKey,
        this.reverse ? 'desc' : 'asc'
      )
      .subscribe(
        data => this.processSuccessList(data.data),
        () => this.processErrorList()
      );
  }

  processSuccessList(data) {
    if (data) {
      this.rows = [];
      for (let i = 0; i < data.hits.hits.length; i++) {
        if (data.hits.hits[i]._source !== null) {
          this.rows.push(data.hits.hits[i]._source);
        }
      }
      this.totalItems = data.hits.total.value;
    } else {
      this.processErrorList();
    }
  }

  processErrorList() {
    this.toastDeprecatedService.alert('wallboard:viewWallboard.toast.getError');
  }

  removeWallboard() {
    if (this.wallboardIdToDelete != null) {
      this.wallboardService.deleteWallboard(this.wallboardIdToDelete).then(
        data => this.removeProcessed(data),
        () => this.removeErrorOccurred()
      );
    }
  }

  removeProcessed(e) {
    if (e) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:viewWallboard.toast.deleteSuccess', ToastClass.WALLBOARD, 1500);
      this.rows.splice(this.wallboardIndexTodelete, 1);
      this.profileFacade.removeVisibleWallboard(this.wallboardIdToDelete);
      this.closeConfirmDelete();
    } else {
      this.removeErrorOccurred();
    }
  }

  removeErrorOccurred() {
    this.toastDeprecatedService.alert('wallboard:viewWallboard.toast.deleteError');
    this.closeConfirmDelete();
  }

  addWallboard() {
    let newWallboard = {
      name: this.newWallboard.name,
      login: this.newWallboard.login,
      mail: this.newWallboard.mail,
      domainUuid: this.newWallboard.domain.uuid,
      template: this.newWallboard.template === '' ? '[]' : this.newWallboard.template,
      positioning: this.newWallboard.positioning,
      spacing: this.newWallboard.spacing,
    };
    this.wallboardService.addWallboard(newWallboard).then(
      data => this.addProcessed(data),
      response => this.addErrorOccurred(response)
    );
  }

  addProcessed(e) {
    if (e.data) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:viewWallboard.toast.addSuccess', ToastClass.WALLBOARD, 1500);
      this.closeWallboardCreation();
      this.profileFacade.addVisibleWallboard(e.data.data);
      setTimeout(() => this.getWallboardList(), 1000);
    } else {
      this.addErrorOccurred(e);
    }
  }

  addErrorOccurred(response) {
    if (response.data != null && response.data.errorCode === 'LOGIN_USED') {
      this.toastDeprecatedService.alert('wallboard:viewWallboard.toast.addErrorLogin');
    } else {
      this.toastDeprecatedService.alert('wallboard:viewWallboard.toast.addError');
    }
    this.closeWallboardCreation();
  }

  openWallboard(wallboard) {
    this.router.navigate([Path.wallboard, wallboard.login]);
  }

  openWallboardCreation() {
    this.newWallboardState = true;
  }

  openWallboardImport() {
    this.newWallboardImportState = true;
    this.openWallboardCreation();
  }

  exportWallboard(wallboard) {
    this.wallboardService.exportWallboard(fromJson(wallboard.template), wallboard.name);
  }

  closeWallboardCreation() {
    this.newWallboard = {
      name: '',
      login: '',
      mail: '',
      domain: null,
      positioning: '',
      spacing: '12',
      template: '',
    };
    this.wbForm.$setPristine();
    this.newWallboardState = false;
    this.newWallboardImportState = false;
  }

  openConfirmDelete(wallboard, index) {
    this.wallboardIdToDelete = wallboard.uuid;
    this.wallboardIndexTodelete = index;
    this.confirmDeleteState = true;
  }

  closeConfirmDelete() {
    this.confirmDeleteState = false;
    this.wallboardIdToDelete = null;
    this.wallboardIndexTodelete = null;
  }
}

export class WallboardList implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {} as { [binding: string]: string };
  controller = ['toastDeprecatedService', 'wallboardService', 'profileFacade', 'wallboardConfRouter', WallboardListCtrl];
}

export default 'wallboardList';
